import { useEffect } from 'react';
import { useURLSearchParams } from '../../helpers/url/useCurrentUrl.js';
import { useAppDispatch } from '../../redux/hooks.js';
import { setGivenName } from '../../redux/features/loginWithLinkedIn/loginWithLinkedInSlice.js';
import { removeCurrentSearchParams } from '../../helpers/url/url.js';
export const UrlBasedModalDispatcher = () => {
    const searchParams = useURLSearchParams();
    const dispatch = useAppDispatch();
    useEffect(() => {
        if (!searchParams) {
            return;
        }
        const hasImportProfileParam = searchParams.has('linkedInShowImportProfile');
        const givenName = searchParams.get('givenName');
        const linkedInAuthError = searchParams.get('linkedInAuthError');
        if (givenName) {
            dispatch(setGivenName(givenName));
            removeCurrentSearchParams(['givenName']);
        }
        if (hasImportProfileParam) {
            document.dispatchEvent(new Event('SHOW_LINKEDIN_IMPORT_PROFILE_MODAL'));
        }
        if (linkedInAuthError) {
            removeCurrentSearchParams(['linkedInAuthError']);
        }
        // This functionality is paused until we stop triggering QG on homepage.
        // We leave the code fot the future reference
        if (linkedInAuthError) {
            removeCurrentSearchParams(['linkedInAuthError']);
            //   dispatch(
            //     setAuthError({
            //       source: 'linkedIn',
            //       code: 0,
            //       message: linkedInAuthError,
            //     }),
            //   );
            //   // here we can dispatch different events for different modal types
            //   document.dispatchEvent(
            //     new Event('CANDIDATE_PROFILE_SHOW_FULLSCREEN_RLA_MODAL'),
            //   );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchParams]);
    return null;
};
//# sourceMappingURL=UrlBasedModalDispatcher.js.map